module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/action-box/action-box.component.scss
// module id = ./src/app/modules/common-module/components/action-box/action-box.component.scss
// module chunks = 9